import { render, staticRenderFns } from "./firstReviewList.vue?vue&type=template&id=637eefd3&scoped=true"
import script from "./firstReviewList.vue?vue&type=script&lang=js"
export * from "./firstReviewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637eefd3",
  null
  
)

export default component.exports